<template>
  <b-pagination
    :value="currentPage"
    :per-page="pageSize"
    :total-rows="total"
    align="fill"
    class="my-0"
    @input="(newCurrentPage) => setCurrentPage(newCurrentPage)"
  ></b-pagination>
</template>

<script>
import { defineComponent, inject } from '@vue/composition-api'

import { BaseDataTableInjectionKey } from './BaseDataTable.constants'

export default defineComponent({
  name: 'BaseDataTablePagination',
  setup() {
    const { total, pageSize, currentPage, setCurrentPage } = inject(
      BaseDataTableInjectionKey
    )

    return {
      total,
      pageSize,

      currentPage,
      setCurrentPage
    }
  }
})
</script>
